// extracted by mini-css-extract-plugin
export default {"root":"RouteTemplateSettingsModal_root__FjP7X","switch":"RouteTemplateSettingsModal_switch__aKK2D","removeButton":"RouteTemplateSettingsModal_removeButton__sxnn5"};